import { render } from "./simple-modal.vue?vue&type=template&id=ec59525e"
import script from "./simple-modal.vue?vue&type=script&lang=js"
export * from "./simple-modal.vue?vue&type=script&lang=js"

import "./simple-modal.vue?vue&type=style&index=0&id=ec59525e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__